"use client";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import ErrorMessage from "~/components/ErrorMessage";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: {
              xs: 0,
              sm: 4,
            },
            bgcolor: "background.default",
          }}
        >
          <Container
            maxWidth="md"
            sx={{
              px: {
                xs: 0,
                sm: 2,
              },
            }}
          >
            <Card
              elevation={0}
              sx={{
                borderRadius: {
                  xs: 0,
                  sm: 4,
                },
                textAlign: "center",
                bgcolor: "transparent",
              }}
            >
              <CardContent sx={{ p: 6 }}>
                {/* Musical Notes Animation */}
                <Box sx={{ mb: 4, position: "relative", height: 120 }}>
                  {Array.from({ length: 3 }).map((_, i) => (
                    <MusicNoteIcon
                      key={i}
                      sx={{
                        fontSize: 50 + i * 15,
                        position: "absolute",
                        left: `${30 + i * 20}%`,
                        top: `${20 + (i % 2) * 30}px`,
                        animation: `float${i} 3s ease-in-out infinite`,
                        color: "error.main",
                        "@keyframes float0": {
                          "0%, 100%": {
                            transform: "translateY(0px) rotate(0deg)",
                          },
                          "50%": {
                            transform: "translateY(-20px) rotate(10deg)",
                          },
                        },
                        "@keyframes float1": {
                          "0%, 100%": {
                            transform: "translateY(0px) rotate(0deg)",
                          },
                          "50%": {
                            transform: "translateY(-15px) rotate(-10deg)",
                          },
                        },
                        "@keyframes float2": {
                          "0%, 100%": {
                            transform: "translateY(0px) rotate(0deg)",
                          },
                          "50%": {
                            transform: "translateY(-25px) rotate(5deg)",
                          },
                        },
                      }}
                    />
                  ))}
                </Box>

                <Typography variant="h4" sx={{ mb: 2, color: "error.main" }}>
                  Ceva nu a mers bine!
                </Typography>
                <Typography variant="h6" sx={{ mb: 3, fontStyle: "italic" }}>
                  Ne pare rău, a apărut o eroare neașteptată.
                </Typography>
                <ErrorMessage
                  digest={error.digest}
                  error={error}
                  sx={{ mb: 4 }}
                />
                <Typography sx={{ mb: 4 }}>
                  Nu-ți face griji - poți încerca din nou să continui aventura
                  muzicală.
                </Typography>

                <Button
                  onClick={() => reset()}
                  variant="contained"
                  size="large"
                  sx={{
                    py: 2,
                    px: 4,
                    fontSize: "1.1rem",
                    "&:hover": {
                      transform: "translateY(-2px)",
                    },
                    transition: "all 0.3s",
                  }}
                >
                  Încearcă din nou
                </Button>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </body>
    </html>
  );
}
